import Button from '@pelckmans/elementis/components/button';
import Dialog from '@pelckmans/elementis/components/dialog';
import { useContext } from 'react';
import { ExerciseResult } from '../../@types/exercise-types';
import { useExerciseManagerContext } from '../../contexts/ExerciseManagerContext';
import { ExerciseTranslationsContext } from '../../contexts/ExerciseTranslationsContext';
import ExerciseHighLightedItem from '../exercise-highlighted-item';
import ExerciseHighlightedItemTags from '../exercise-highlighted-item-tags';

interface ProgressionModalPausedSessionProps {
  result: ExerciseResult;
  onRestart?: () => void; // hidden with assignments that are not repeatable, how can this be determined?
  onResume: () => void;
}

function ProgressionModalPausedSession({ result, onRestart, onResume }: ProgressionModalPausedSessionProps) {
  const translations = useContext(ExerciseTranslationsContext);

  const { medialink, module, onClose } = useExerciseManagerContext();

  return (
    <Dialog
      id="progression-modal-paused-session"
      modal
      onClose={onClose}
      aria-label={translations.progressionModalPausedSession.a11yLabel}
    >
      <Dialog.Header
        title={translations.progressionModalPausedSession.title}
        onClose={onClose}
        aria-label={translations.closeDialog}
      />
      <Dialog.Body>
        <div className="modal-content-text">
          <p>{translations.progressionModalPausedSession.message}</p>
        </div>
        <ExerciseHighLightedItem
          status="busy"
          medialink={medialink}
          title={translations.progressionModalPausedSession.highlightedItem.title}
          scoreTitle={translations.progressionModalPausedSession.highlightedItem.score}
          percentageTitle={translations.progressionModalPausedSession.highlightedItem.percentage}
          result={{
            title: translations.progressionModalPausedSession.highlightedItem.resultTitle,
            score: result.score,
          }}
          tags={{
            'aria-label': undefined,
            role: undefined,
            children: (
              <ExerciseHighlightedItemTags
                module={module}
                medialink={medialink}
                translations={translations.progressionModalPausedSession.highlightedItem}
              />
            ),
          }}
        />
      </Dialog.Body>
      <Dialog.Footer
        buttonGroupPropsLeft={
          onRestart
            ? {
                'aria-label': undefined,
                role: undefined,
                children: (
                  <Button prominence="neutral" onClick={onRestart}>
                    {translations.progressionModalPausedSession.buttons.restart}
                  </Button>
                ),
              }
            : undefined
        }
        buttonGroupPropsRight={{
          'aria-label': undefined,
          role: undefined,
          children: (
            <>
              <Button onClick={onResume} prominence="neutral" key="neutral">
                {translations.progressionModalPausedSession.buttons.resume}
              </Button>
              <Button onClick={onClose} prominence="success" key="success">
                {translations.progressionModalPausedSession.buttons.close}
              </Button>
            </>
          ),
        }}
      />
    </Dialog>
  );
}

export default ProgressionModalPausedSession;
